<template>
  <div class="dialog-overlay" v-if="visible" @click.self="closeDropdowns">
    <div class="dialog-container">
      <div class="dialog-header">
        <div class="header-content">
          <h3>{{ course.id ? "编辑课程" : "新增课程" }}</h3>
          <div class="action-buttons">
            <!--            <button class="download-btn" @click="downloadTemplate">-->
            <!--              <img src="@/assets/download-icon.png" alt="下载模板" class="icon">-->
            <!--              <span>下载试题模板</span>-->
            <!--            </button>-->
            <!--            <button class="import-btn" @click="importQuestions">-->
            <!--              <img src="@/assets/import-icon.png" alt="上传试题" class="icon">-->
            <!--              <span>上传试题</span>-->
            <!--            </button>-->
          </div>
        </div>
        <button class="close-btn" @click="$emit('close')">
          <span>&times;</span>
        </button>
      </div>
      <div class="dialog-content">
        <div class="form-group">
          <label>课程名称</label>
          <input v-model="localCourse.name" type="text" class="form-input" />
        </div>
        <div class="form-group">
          <label>课程类别</label>
          <div class="select-wrapper">
            <input
              v-model="localCourse.courseType"
              type="text"
              class="form-input"
            />
            <img
              src="@/assets/down-icon.png"
              alt="选择类别"
              class="select-icon"
              @click.stop="toggleCategoryDropdown"
            />
            <div class="dropdown-menu" v-show="showCategoryDropdown">
              <div class="dropdown-item" @click="selectCategory('常识类')">
                常识类
              </div>
              <div class="dropdown-item" @click="selectCategory('技术类')">
                技术类
              </div>
              <div class="dropdown-item" @click="selectCategory('财务类')">
                财务类
              </div>
              <div class="dropdown-item" @click="selectCategory('人事类')">
                人事类
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>课程描述</label>
          <textarea
            v-model="localCourse.description"
            class="form-textarea"
          ></textarea>
        </div>
        <div class="form-group">
          <label>指派人员</label>
          <div class="select-wrapper">
            <input
              v-model="localCourse.assigned"
              type="text"
              class="form-input"
              readonly
            />
            <img
              src="@/assets/down-icon.png"
              alt="选择部门"
              class="select-icon"
              @click.stop="toggleDepartmentDropdown"
            />
            <div
              class="dropdown-menu department-dropdown expanded-dropdown"
              v-show="showDepartmentDropdown"
            >
              <div class="dropdown-content-wrapper">
                <div class="departments-list">
                  <div
                    v-for="dept in departments"
                    :key="dept.name"
                    class="department-section"
                  >
                    <div
                      class="department-header"
                      @click.stop="handleDepartmentClick(dept)"
                    >
                      <input
                        type="checkbox"
                        :checked="isDepartmentSelected(dept.name)"
                        @change.stop="toggleDepartmentSelection(dept)"
                        class="dept-checkbox"
                      />
                      <span class="dept-name">{{ dept.name }}</span>
                      <img
                        v-if="dept.expanded"
                        src="@/assets/right-icon.png"
                        alt="已选择"
                        class="selected-icon"
                      />
                    </div>
                  </div>
                </div>
                <div class="members-list-container" v-if="selectedDepartment">
                  <div class="members-list-header">
                    <h4>{{ selectedDepartmentName || "选择部门查看成员" }}</h4>
                  </div>
                  <div class="members-content">
                    <div v-if="loadingMembers" class="loading-text">
                      加载中...
                    </div>
                    <div
                      v-else-if="departmentMembers.length > 0"
                      class="members-container"
                    >
                      <div
                        v-for="member in departmentMembers"
                        :key="member.id"
                        class="member-item"
                      >
                        <input
                          type="checkbox"
                          :checked="isMemberSelected(member.id)"
                          @change.stop="toggleMemberSelection(member)"
                          class="member-checkbox"
                        />
                        <div class="member-avatar">
                          {{ member.name.charAt(0) }}
                        </div>
                        <div class="member-info">
                          <div class="member-name">{{ member.name }}</div>
                          <div class="member-position">
                            {{ member.position || "无职位" }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="no-members">暂无成员</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>学分</label>
            <input
              v-model.number="localCourse.credits"
              type="number"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <label>课程时长(分钟)</label>
            <input
              v-model.number="localCourse.courseTotalTime"
              type="number"
              class="form-input"
            />
          </div>
        </div>
        <div class="form-group">
          <label>封面图片URL</label>
          <input v-model="localCourse.image" type="text" class="form-input" />
        </div>
        <div class="form-group">
          <label>视频URL</label>
          <input
            v-model="localCourse.videoUrl"
            type="text"
            class="form-input"
          />
        </div>
      </div>
      <div class="dialog-footer">
        <button class="btn cancel-btn" @click="$emit('close')">取消</button>
        <button class="btn confirm-btn" @click="handleSave">保存课程</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    course: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localCourse: {
        ...this.course,
        trainingCourse: this.course.trainingCourse || "",
        courseType: this.course.courseType || "",
        assign: this.course.assign || "",
        courseDescription: this.course.courseDescription || "",
        selectedMembers: this.course.selectedMembers || [],
      },
      showCategoryDropdown: false,
      showDepartmentDropdown: false,
      departmentMembers: [], // 存储部门成员列表
      loadingMembers: false,
      saveLoading: false,
      selectedDepartment: "",
      selectedDepartmentName: "",
      departments: [],
      selectedDepartments: [], // 存储选中的部门列表
    };
  },
  watch: {
    course(newVal) {
      this.localCourse = {
        ...newVal,
        trainingCourse: newVal.trainingCourse || "",
        courseType: newVal.courseType || "",
        assign: newVal.assign || "",
        selectedMembers: newVal.selectedMembers || [],
      };
    },
  },
  created() {
    // 页面加载时自动调用getDepartments接口
    this.loadDepartments();
  },
  methods: {
    async loadDepartments() {
      this.loadingMembers = true;
      try {
        const response = await this.$http.get(`/departments`);
        // 确保每个部门都有expanded属性
        this.departments = (response.data || []).map((dept) => ({
          ...dept,
          name: dept.depart || dept.name, // 处理可能的字段名差异
          expanded: false,
        }));
        console.log("部门列表:", this.departments);
      } catch (error) {
        console.error("获取部门列表失败:", error);
        this.departments = [];
      } finally {
        this.loadingMembers = false;
      }
    },

    async handleDepartmentClick(dept) {
      // 取消之前选中的部门状态
      this.departments.forEach((department) => {
        if (department.name !== dept.name) {
          department.expanded = false;
        }
      });

      // 设置当前选中的部门
      dept.expanded = true;
      this.selectedDepartment = dept.name;
      this.selectedDepartmentName = dept.name;

      // 加载该部门的成员
      await this.loadDepartmentMembers(dept.name);
    },

    toggleDepartmentSelection(dept) {
      const isSelected = this.isDepartmentSelected(dept.name);

      if (isSelected) {
        this.selectedDepartments = this.selectedDepartments.filter(
          (name) => name !== dept.name
        );
      } else {
        this.selectedDepartments.push(dept.name);
      }

      this.updateAssignedInput();
    },

    isDepartmentSelected(deptName) {
      return this.selectedDepartments.includes(deptName);
    },
    async handleSave() {
      //   if (!this.validateForm()) return
      // 3. 具体字段判空（按需添加）
      // 关键参数判空检查
      if (!this.localCourse) {
        this.$message.error("课程数据未初始化");
        return;
      }

      // 构建需要验证的字段列表
      // 关键参数判空检查
      if (!this.localCourse) {
        console.warn("[验证警告] 课程数据未初始化");
        this.$message.error("课程数据未初始化");
        return;
      }

      const requiredFields = [
        {
          field: this.localCourse.name,
          fieldName: "课程名称", // 添加字段名称用于日志
          message: "课程名称不能为空",
          validator: (value) => {
            console.log(
              `[验证] 正在验证课程名称: "${
                value ? value.substring(0, 10) + "..." : "空值"
              }"`
            );
            return !!value;
          },
        },
        {
          field: this.localCourse.courseType,
          fieldName: "课程类型",
          message: "课程类型未选择",
          validator: (value) => {
            console.log(`[验证] 正在验证课程类型: "${value || "未选择"}"`);
            return !!value;
          },
        },
        {
          field: this.localCourse.description,
          fieldName: "课程描述",
          message: "课程主题描述没有写",
          validator: (value) => {
            // 1. 打印原始值用于调试
            console.log(`[验证] 课程描述原始值:`, {
              value: value,
              type: typeof value,
              isEmpty: value === undefined || value === null || value === "",
            });
            // 2. 更严格的非空验证
            if (value === undefined || value === null) {
              console.warn("[验证警告] 课程描述未定义或为null");
              return false;
            }

            if (typeof value === "string") {
              // 如果是字符串，去除首尾空格后再判断
              const trimmedValue = value.trim();
              console.log(`[验证] 课程描述处理后值: "${trimmedValue}"`);

              if (trimmedValue === "") {
                console.warn("[验证警告] 课程描述为空字符串");
                return false;
              }

              // 如果是汉字，这里会返回true
              return true;
            }
            return false;
          },
        },
        {
          field: this.localCourse.videoUrl,
          fieldName: "课程链接",
          message: "课程链接必须以 http:// 或 https:// 开头",
          validator: (value) => {
            if (!value) {
              console.warn("[验证警告] 课程链接为空");
              return false;
            }

            console.log(
              `[验证] 正在验证课程链接: "${value.substring(0, 30)}..."`
            );
            const isValid =
              value.startsWith("http://") || value.startsWith("https://");

            if (!isValid) {
              console.warn(`[验证失败] 课程链接格式不正确: ${value}`);
            }

            return isValid;
          },
        },
        {
          field: this.localCourse.image,
          fieldName: "封面链接",
          message: "课程封面链接必须以 http:// 或 https:// 开头",
          validator: (value) => {
            if (!value) {
              console.warn("[验证警告] 封面链接为空");
              return false;
            }

            console.log(
              `[验证] 正在验证封面链接: "${value.substring(0, 30)}..."`
            );
            const isValid =
              value.startsWith("http://") || value.startsWith("https://");

            if (!isValid) {
              console.warn(`[验证失败] 封面链接格式不正确: ${value}`);
            }

            return isValid;
          },
        },
      ];

      for (const item of requiredFields) {
        try {
          const isValid = item.validator(item.field);
          if (!isValid) {
            console.error(
              `[验证终止] ${item.message} - 字段: ${item.fieldName}`
            );
            this.$message.error(item.message);
            return;
          }
        } catch (error) {
          console.error(`[验证异常] 验证 ${item.fieldName} 时出错:`, error);
          this.$message.error(`验证过程中发生错误，请稍后重试`);
          return;
        }
      }

      console.log("[验证通过] 所有字段验证成功");
      this.saveLoading = true;
      try {
        // 获取开始日期
        const startDate =
          this.localCourse.startDate || new Date().toISOString().split("T")[0];

        // 计算结束日期（开始日期后一个月）
        let endDate = this.localCourse.endDate;
        if (!endDate) {
          endDate = this.calculateEndDate(startDate);
        }

        const baseRequestData = {
          number: this.localCourse.number || this.generateCourseNumber(),
          startDate: startDate,
          endDate: endDate,
          trainingCourse: this.localCourse.name,
          courseDescription: this.localCourse.description,
          courseType: this.localCourse.courseType || "online",
          courseUrl: this.localCourse.videoUrl,
          coverUrl: this.localCourse.image,
          credits: this.localCourse.credits?.toString() || "0",
          courseTotalTime: this.localCourse.courseTotalTime?.toString() || "60",
          assign: this.localCourse.assigned,
        };

        // 如果是编辑模式，添加ID
        if (this.localCourse.id) {
          baseRequestData.id = this.localCourse.id;
        }

        // 获取选中的成员列表，如果没有选中成员，则使用默认值
        const members =
          this.localCourse.selectedMembers.length > 0
            ? this.localCourse.selectedMembers
            : [{ name: "默认用户" }];

        console.log("批量添加培训记录的成员数量:", members.length);

        // 为每个成员创建API调用
        const promises = members.map(async (member, index) => {
          const requestData = {
            ...baseRequestData,
            name: member.name || "未知用户",
            // 为每个记录生成唯一编号，避免重复
            number: `${baseRequestData.number}_${index + 1}`,
          };

          console.log(
            `为用户 ${member.name} 创建的请求数据:`,
            JSON.stringify(requestData, null, 2)
          );

          // 发送POST请求到后端接口
          return this.$http.post("/training/addRecord", requestData, {
            headers: {
              "Content-Type": "application/json",
            },
          });
        });

        // 并行执行所有API调用
        const responses = await Promise.all(promises);

        // 检查所有响应是否成功
        const allSuccess = responses.every((response) => response.data.success);

        if (allSuccess) {
          this.$message.success(`成功为 ${members.length} 位人员添加培训记录`);
          this.$emit("save", { ...this.localCourse });
          this.$emit("close");
        } else {
          // 统计成功和失败的数量
          const successCount = responses.filter((r) => r.data.success).length;
          this.$message.error(
            `部分记录添加失败: 成功 ${successCount} 条，失败 ${
              members.length - successCount
            } 条`
          );
        }
      } catch (error) {
        console.error("批量添加培训记录失败:", {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data,
          config: error.config,
        });

        // 根据错误类型提供更具体的错误信息
        if (error.response) {
          // 服务器返回错误响应
          const errorMessage =
            error.response.data?.message ||
            `服务器错误 (${error.response.status})`;
          this.$message.error(`批量添加失败: ${errorMessage}`);
        } else if (error.request) {
          // 请求已发送但未收到响应
          this.$message.error("网络连接异常，请检查服务器是否正常运行");
        } else {
          // 请求配置错误
          this.$message.error(`请求配置错误: ${error.message}`);
        }
      } finally {
        this.saveLoading = false;
      }
    },
    // 新增方法：计算结束日期（开始日期后一个月）
    calculateEndDate(startDate) {
      const date = new Date(startDate);
      date.setMonth(date.getMonth() + 1);

      // 格式化日期为 YYYY-MM-DD
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    generateCourseNumber() {
      const timestamp = new Date().getTime();
      return "COURSE_" + timestamp;
    },

    downloadTemplate() {
      console.log("下载试题模板");
    },
    importQuestions() {
      console.log("上传试题");
    },
    // selectCategory(category) {
    //   this.localCourse.courseType = category
    //   this.showCategoryDropdown = false
    // },
    // async selectDepartment(department) {
    //   this.localCourse.assigned = department
    //   this.showDepartmentDropdown = false;
    //   // 调用接口查询部门成员
    //   await this.fetchDepartmentMembers(department);
    // },
    toggleCategoryDropdown() {
      this.showCategoryDropdown = !this.showCategoryDropdown;
      this.showDepartmentDropdown = false;
    },
    toggleDepartmentDropdown() {
      this.showDepartmentDropdown = !this.showDepartmentDropdown;
      this.showCategoryDropdown = false;
    },
    async toggleDepartmentMembers(departmentName) {
      const department = this.departments.find(
        (dept) => dept.name === departmentName
      );
      if (!department) return;

      department.expanded = !department.expanded;
      this.selectedDepartment = departmentName;

      if (department.expanded) {
        await this.loadDepartmentMembers(departmentName);
      } else {
        this.departmentMembers = [];
      }
    },

    async loadDepartmentMembers(departmentName) {
      this.loadingMembers = true;
      try {
        const response = await this.$http.get(`/depart/${departmentName}`);
        this.departmentMembers = response.data || [];
      } catch (error) {
        console.error("获取部门成员失败:", error);
        this.departmentMembers = [];
      } finally {
        this.loadingMembers = false;
      }
    },

    toggleMemberSelection(member) {
      const isSelected = this.isMemberSelected(member.id);

      if (isSelected) {
        this.localCourse.selectedMembers =
          this.localCourse.selectedMembers.filter((m) => m.id !== member.id);
      } else {
        this.localCourse.selectedMembers.push(member);
      }

      this.updateAssignedInput();
    },

    isMemberSelected(memberId) {
      return this.localCourse.selectedMembers.some((m) => m.id === memberId);
    },

    updateAssignedInput() {
      // 组合选中的部门和人员信息
      const assignedParts = [];

      if (this.selectedDepartments.length > 0) {
        assignedParts.push(`部门: ${this.selectedDepartments.join(", ")}`);
      }

      if (this.localCourse.selectedMembers.length > 0) {
        assignedParts.push(
          `${this.localCourse.selectedMembers.map((m) => m.name).join(", ")}`
        );
      }

      this.localCourse.assigned =
        assignedParts.length > 0 ? assignedParts.join(" | ") : "";
    },

    selectCategory(category) {
      this.localCourse.courseType = category;
      this.showCategoryDropdown = false;
    },
    closeDropdowns() {
      this.showCategoryDropdown = false;
      this.showDepartmentDropdown = false;
    },
  },
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-container {
  background-color: white;
  border-radius: 8px;
  width: 650px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  padding: 16px 24px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  padding: 4px;
  margin-left: 16px;
}

.close-btn:hover {
  color: #666;
}

.download-btn,
.import-btn {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.download-btn:hover,
.import-btn:hover {
  background-color: #40a9ff;
}

.download-btn .icon,
.import-btn .icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

.dialog-content {
  padding: 24px 32px;
}

.form-group {
  margin-bottom: 16px;
  padding: 0 16px;
}

.form-row {
  display: flex;
  gap: 16px;
  padding: 0 16px;
}

.form-row .form-group {
  flex: 1;
  padding: 0;
}

label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #666;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 8px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus,
.form-textarea:focus {
  border-color: #1890ff;
  outline: none;
}

.form-textarea {
  min-height: 80px;
  resize: vertical;
}

.select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.select-icon {
  position: absolute;
  right: 16px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  width: 200px;
  background-color: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 10;
  margin-top: 4px;
}

/* 扩大的下拉菜单 */
.expanded-dropdown {
  width: 450px;
  max-height: 400px;
}

/* 下拉内容容器 */
.dropdown-content-wrapper {
  display: flex;
  height: 100%;
  min-height: 300px;
}

/* 部门列表 */
.departments-list {
  width: 200px;
  border-right: 1px solid #e8e8e8;
  overflow-y: auto;
}

/* 成员列表容器 */
.members-list-container {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

/* 成员列表头部 */
.members-list-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fafafa;
}

.members-list-header h4 {
  margin: 0;
  font-size: 14px;
  color: #333;
}

/* 成员内容区域 */
.members-content {
  flex: 1;
  overflow-y: auto;
}

/* 部门头部样式 */
.department-header {
  padding: 10px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.2s;
  position: relative;
}

.department-header:hover {
  background-color: #f5f5f5;
}

.dept-checkbox {
  margin-right: 8px;
  cursor: pointer;
}

.dept-name {
  flex: 1;
  font-size: 14px;
}

.selected-icon {
  width: 16px;
  height: 16px;
  color: #1890ff;
}

.department-header.selected {
  background-color: #e6f7ff;
  color: #1890ff;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.dialog-footer {
  padding: 16px 32px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.cancel-btn {
  background-color: white;
  border: 1px solid #d9d9d9;
  color: #666;
}

.cancel-btn:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.confirm-btn {
  background-color: #1890ff;
  border: 1px solid #1890ff;
  color: white;
}
.expand-icon {
  width: 12px;
  height: 12px;
}

.members-list {
  background-color: #fafafa;
  border-top: 1px solid #eee;
}
.confirm-btn:hover {
  background-color: #40a9ff;
  border-color: #40a9ff;
}
.members-container {
  max-height: 200px;
  overflow-y: auto;
}

.member-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.member-item:hover {
  background-color: #e8f4fd;
}

.member-checkbox {
  margin-right: 12px;
  cursor: pointer;
}

.member-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #4a90e2;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 14px;
  font-weight: 500;
}

.member-info {
  flex: 1;
}

.member-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.member-position {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

.loading-text {
  padding: 10px;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.no-members {
  padding: 12px;
  text-align: center;
  color: #999;
  font-size: 10px;
}
</style>
